import { Text } from '@mantine/core'
import dayjs from 'dayjs'

/**
 * Quando o pedido foi feito, com DIA — não só hora.
 *
 * Em 26/08/2026 dois Web ACLs foram criados numa conta de cliente porque o
 * operador clicou em "Tentar de novo" em cartões de 10/08: os cartões
 * terminais não imprimiam data nenhuma, e os horários visíveis eram os passos
 * da timeline, só hora. O formato é o mesmo de `WafProvisioningHistory` de
 * propósito — dois formatos de data na mesma tela ensinam a não ler nenhum.
 */
export function QuandoPedido({ iso }: { iso: string }) {
  return (
    <Text size="xs" c="dimmed" mt={4}>
      Pedido em {dayjs(iso).format('DD/MM/YYYY HH:mm')}
    </Text>
  )
}
